import { Body, HorizontalSpacer, Icon } from '@superhi/design'
import React from 'react'

type Props = {}

const Point: React.FC<React.PropsWithChildren<Props>> = ({ children }) => (
  <HorizontalSpacer amount={{ small: 8, medium: 8, large: 8 }}>
    <Icon name="wilson" color="BLUE_50" />
    <Body level="2" bold>
      {children}
    </Body>
  </HorizontalSpacer>
)

export default Point
